import React from 'react';
import SCH from '../../assets/img/sch.png';
import KCC from '../../assets/img/kcc.png';
import { Container, Row, Col } from 'reactstrap';
import './TitlePage.css';
import { BrowserView, TabletView } from 'react-device-detect';

const TitlePage = () => (
  <div>
    <BrowserView>
      <header className="App-header">
        <h1 className="App-title">

          <Container fluid>
            <Row>
              <Col xs="6" sm="4">
                <img src={SCH} className="SCH-logo" alt="SCH" />
              </Col>
              <Col xs="6" sm="4" className="App-text">
                Digital Paediatric Cancer Survivorship Triage Tool{' '}
              </Col>
              <Col xs="6" sm="4">
                <img src={KCC} className="KCC-logo" alt="KCC" />
              </Col>
            </Row>
          </Container>
        </h1>
      </header>
    </BrowserView>
    <TabletView>

      <header className="App-header">
        <h1 className="App-title">

          <Container fluid>
            <Row>
              <Col xs="6" sm="auto">
                <img src={SCH} className="SCH-logo-mobile" alt="SCH" />
              </Col>
              <Col xs="6" sm="4" className="App-text">
                  Digital Paediatric Cancer Survivorship Triage Tool{' '}
              </Col>
              <Col xs="6" sm="auto">
                <img src={KCC} className="KCC-logo-mobile" alt="KCC" />
              </Col>
            </Row>
          </Container>
        </h1>
      </header>
    </TabletView>
    {/* </Link> */}
  </div>
);

export default TitlePage;



// WEBPACK FOOTER //
// ./src/containers/Header/TitlePage.js